import { render, staticRenderFns } from "./main-news.vue?vue&type=template&id=2bb18653&scoped=true&"
import script from "./main-news.vue?vue&type=script&lang=js&"
export * from "./main-news.vue?vue&type=script&lang=js&"
import style0 from "./main-news.vue?vue&type=style&index=0&id=2bb18653&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb18653",
  null
  
)

export default component.exports